<template>
<div id="f-section">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 hearder-row">
               <div class="section-header">
                     <div class="col-xs-12 text-center">
                        <h2>نحن حريصون على</h2>
                      </div>            
                        
                 </div>   
            </div>  
            <div class="row features-row">
                <div class="col-sm-3">
                <div class="section-div">
                   <div class="icon-div">
                        <span>
                            <i  class="fa fa-braille "></i>
                                <hr>
                        </span>
                         <svg version="1.1" id="Layer_1" xlmns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 300 320" xml:space="preserve">
                            <g>
                                <polygon points="22.3,223.7 22.3,76.3 150,2.5 277.7,76.3 277.7,223.7 150,297.5 	"></polygon>
                            </g>
                        </svg>
                   </div>
                   
                   <h1>العناية بالتفاصيل</h1>
                    <div class="description">
                        <p>
                            تلك التفاصيل الصغيرة تهمنا، نعتني بها لنقدم لكم تجربة فريدة وجودة عالية
                        </p>
                    </div>
                </div>    
            </div> 
             <div class="col-sm-3">
                <div class="section-div">
                    <div class="icon-div">
                        <span>
                            <i  class="fab fa-connectdevelop "></i>
                                <hr>
                        </span>
                         <svg version="1.1" id="Layer_1" xlmns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 300 320" xml:space="preserve">
                            <g>
                                <polygon points="22.3,223.7 22.3,76.3 150,2.5 277.7,76.3 277.7,223.7 150,297.5 	"></polygon>
                            </g>
                        </svg>
                   </div>
                   <h1>التطوير المستمر</h1>
                    <div class="description"><p>منتجك في بيترونيكس لن يتوقف عند حد ما بل سيواكب التطورات المستمرة للتقنية ليطابق آخر المعايير الدولية</p> </div>
                </div>    
            </div> 
             <div class="col-sm-3">
                <div class="section-div">
                    <div class="icon-div">
                        <span>
                            <i  class="far fa-handshake-o"></i>
                                <hr>
                        </span>
                         <svg version="1.1" id="Layer_1" xlmns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 300 320" xml:space="preserve">
                            <g>
                                <polygon points="22.3,223.7 22.3,76.3 150,2.5 277.7,76.3 277.7,223.7 150,297.5 	"></polygon>
                            </g>
                        </svg>

                   </div>
                   <h1>الاستمرار بالتواصل</h1>
                    <div class="description">
                        <p>نسعى في بيترونكس دائماً إلى الإبقاء على علاقات متواصلة مع عملائنا لنطمئن عن رضاهم وارتياحهم لمنتجاتنا</p>
                    </div>
                </div>    
            </div>
            <div class="col-sm-3">
                <div class="section-div">
                    <div class="icon-div">
                        <span>
                            <i  class="fas fa-headphones"></i>
                                <hr>
                        </span>
                         <svg version="1.1" id="Layer_1" xlmns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 300 320" xml:space="preserve">
                            <g>
                                <polygon points="22.3,223.7 22.3,76.3 150,2.5 277.7,76.3 277.7,223.7 150,297.5 	"></polygon>
                            </g>
                        </svg>
                   </div>
                   <h1>الدعم الفني</h1>
                    <div class="description">
                        <p>
                            نؤمن في بيترونيكس أنّ لا قيمة لمنتج من دون دعم فني قوي له، لذلك حصولك على منتج في بيترونيكس يعني حصولك على دعم فني كامل عند طلبك
                        </p>
                    </div>
                </div>    
            </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  name:'f-section'
}
</script>
<style lang="scss">
@import "src/assets/sass/shared.scss";

    #f-section{
        .section-title{
            margin-bottom:20px;
            h1{
                text-align: center;
            }
        }
       .hearder-row{
           margin-bottom:30px;
       }
       .features-row{
           clear:both;
       }
        .section-div{
            display:flex;
            margin-left:-15px;
            margin-right:-15px;
            margin-bottom:30px;
            flex-direction: column;
            text-align:center;
            .icon-div{
                position: relative;
                text-align: center;
                svg {
                    width:120px;
                    polygon{
                        fill:$main-color;

                    }
                }
                span{
                    position: absolute;
                    text-align: center;
                    color: #fff;
                    z-index: 45;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                    width:100%;
                    height:100%;
                    flex-direction: column;
                        hr{
                            margin-top:10px;
                            width:50px;
                        }
                }
            }
             
            h1{
                font-size:28px;
            }          
            i{
                font-size:24px;
                color:#fff;
            }
            .description{
                padding:10px;
                margin-bottom:10px;
                p{
                    @include multiline-ellipses(15px,1.2,5);
                    @media(max-width:767px){
                        width:85%;
                    }
                    
                }
            }
            &:nth-child(even){
                border-left:1px solid #ccc;
            }
        }
        .hex-container{
                width:100%;
                margin-top:10px;
                display:flex;
                justify-content: center;
            }

        //
        .hex {
            width:100px;
            height:56px;
            background-color: $main-color;
            background-repeat: no-repeat;
            background-position: 50% 50%;			
            background-size: auto 173px;							
            position: relative;
            float:left;
            margin:25px 5px;
            text-align:center;
            zoom:1;
            border-left:2px solid $main-color;
            border-right: 2px solid $main-color;

            a {
                display:block;
                width: 100%;
                height:100%;
                text-indent:-9999em;
                position:absolute;
                top:0;
                left:0;
            }
            .corner-1 , .corner-2{
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
                background: inherit;								
                z-index:-2;						
                overflow:hidden;		
                backface-visibility: hidden;	
                
                &:before{
                    width: 173px;
                    height:	173px;
                    content: '';
                    position: absolute;
                    background: inherit;
                    top:0;
                    left: 0;
                    z-index: 1;
                    background: inherit;
                    background-repeat:no-repeat;
                    backface-visibility: hidden;	
                }
            }
            .corner-1 {
                z-index:-1;
                transform: rotate(60deg);
                &:before{
                    transform: rotate(-60deg) translate(-87px, 0px);	
	                 transform-origin: 0 0;
                }
            }
            .corner-2 {
                transform: rotate(-60deg);
                &:before{
                    transform: rotate(60deg) translate(-48px, -11px);	
		            bottom:0;
                }
            }
            .inner{
                color:#fff;
                hr{
                    border:0;
                    border-top:1px solid #eee;
                    width:60%;
                    margin:15px auto;
                }
            }
        }
	
        //
        
    }
   
</style>



// WEBPACK FOOTER //
// src/components/home/f-section.vue